<template>
  <div class="container connection-answer-container">
    <div class="top-section">
      <span class="title">{{ CONSTANTS.getCopy('CONNECTIONANSWER_TOP_TITLE') }}</span>
      <span class="icon" @click="closeConnectionView()"><i class="fas fa-times"></i></span>
    </div>
    <div class="columns form-section">
      <div class="column">
        <label class="label">{{ CONSTANTS.getCopy('CONNECTIONANSWER_PROCESS_LABEL') }}</label>
        <input type="text" class="is-full-width" :class="{'input-error': showErrors && !data.process}"
               v-model="data.process" v-bind:placeholder="CONSTANTS.getCopy('CONNECTIONANSWER_PROCESS_PLACEHOLDER')"/>
        <div class="ptop-1 is-flex-row">
          <div class="is-flex-column is-middle-width pright-1">
            <label class="label">{{ CONSTANTS.getCopy('CONNECTIONANSWER_METHOD_LABEL') }}</label>
            <select v-model="data.method" :class="{'input-error': showErrors && !data.method}">
                  <option v-for="method in methods" :key="method.idTypeResponse" :value="method.idTypeResponse">
                    {{ method.typeResponse }}
                  </option>
                </select>
          </div>
          <div class="is-flex-column is-middle-width">
            <label class="label">{{ CONSTANTS.getCopy('CONNECTIONANSWER_CONTENT_TYPE_LABEL') }}</label>
            <select v-model="data.contentType" :class="{'input-error': showErrors && !data.contentType}">
              <option v-for="contentType in contentTypes" :key="contentType.idTypeResponse"
                :value="contentType.idTypeResponse">
                {{ contentType.typeResponse }}
              </option>
            </select>
          </div>
        </div>
        <label class="ptop-1 label">{{ CONSTANTS.getCopy('CONNECTIONANSWER_SUBS_PARAM_LABEL') }}</label>
        <textarea class="is-full-width" v-bind:placeholder="CONSTANTS.getCopy('CONNECTIONANSWER_SUBS_PARAMS_PLACEHOLDER')"
                  v-model="data.parametersList"></textarea>
        <label class="ptop-1 label">{{ CONSTANTS.getCopy('CONNECTIONANSWER_URL_PARAMS_LABEL') }}</label>
        <textarea class="is-full-width" v-bind:placeholder="CONSTANTS.getCopy('CONNECTIONANSWER_URL_PARAMS_PLACEHOLDER')"
                  v-model="data.parameters"></textarea>
        <label class="ptop-1 label">{{ CONSTANTS.getCopy('CONNECTIONANSWER_ERROR_RESPONSE_LABEL') }}</label>
        <textarea class="is-full-width" v-bind:placeholder="CONSTANTS.getCopy('CONNECTIONANSWER_ERROR_RESPONSE_PLACEHOLDER')"
                  v-model="data.responseError"></textarea>
      </div>
      <div class="column">
        <div class="field">
          <label class="label">{{ CONSTANTS.getCopy('CONNECTIONANSWER_HELP_RESPONSE_LABEL') }}</label>
          <div v-for="(response, index) in responseHelpArray" :key="index" class="control">
            <textarea v-model="responseHelpArray[index]" class="is-full-width" :id="`response${index}`"
                      v-bind:placeholder="CONSTANTS.getCopy('CONNECTIONANSWER_HELP_RESPONSE_PLACEHOLDER')"
                      @click="boxFocus = index" @focus="sentencePosition = 0"
                      :class="{'input-error': showErrors && !data.responseHelp}">
            </textarea>
            <span class="icon close-box" @click="deleteResponse(index)"><i class="fas fa-times"></i></span>
          </div>
        </div>
        <div class="is-flex-row-center buttons">
          <div class="button" :class="{'is-primary': showEmojis}" @click="showEmojis = !showEmojis">😀</div>
          <div class="button" @click="addResponse">+</div>
        </div>
        <emojis v-if="showEmojis" @emoji-selected="addElement"></emojis>
      </div>
    </div>
    <div class="bottom-section">
      <div class="is-right-bottom">
        <div class="button is-primary" @click="saveAnswer">
          <span class="icon"><i class="fas fa-save fa-lg"></i></span>
          <span class="is-capitalized">{{ CONSTANTS.getCopy('CONNECTIONANSWER_SAVE_BUTTON') }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Answers from '../../../../lib/AnswersMethods'
import Emojis from '../../../templates/Emojis'
export default {
  components: {Emojis},
  props: { answer: Object },
  data () {
    return {
      data: {
        process: null,
        method: null,
        contentType: null,
        parametersList: null,
        parameters: null,
        responseHelp: null,
        responseError: null
      },
      responseHelpArray: [],
      showEmojis: false,
      boxFocus: 0,
      sentencePosition: 0,
      methods: {},
      contentTypes: {},
      showErrors: false
    }
  },
  created () {
    this.responseHelpArray.push(null)
    this.getContentTypes()
    this.getMethods()
    if (this.answer) {
      this.data = this.answer
      this.responseHelpArray = this.answer.responseHelp.split('[SALTO_MENSAJE]')
    }
  },
  methods: {
    closeConnectionView () {
      this.$emit('closeConnectionView')
    },
    addResponse () {
      this.responseHelpArray.push(null)
    },
    getContentTypes () {
      this.api.post('/DataTypeContentList').then(response => {
        this.contentTypes = response.typesResponse
      })
    },
    getMethods () {
      this.api.post('/DataTypeMethodList').then(response => {
        this.methods = response.typesResponse
      })
    },
    deleteResponse (index) {
      this.responseHelpArray.splice(index, 1)
    },
    addElement (syntax) {
      let data = Answers.addElement(syntax, this.responseHelpArray[this.boxFocus], this.sentencePosition, '#response' + this.boxFocus)
      this.responseHelpArray[this.boxFocus] = data.sentence
      this.sentencePosition = data.position
      this.$forceUpdate()
    },
    saveAnswer () {
      this.data.responseHelp = this.responseHelpArray.join('[SALTO_MENSAJE]')
      if (!this.data.process || !this.data.method || !this.data.contentType || !this.data.responseHelp) {
        if (this.responseHelpArray.length < 1) this.responseHelpArray.push(null)
        this.showErrors = true
        return
      }
      this.$emit('saveConnectionData', this.data)
      this.closeConnectionView()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Intents/sentencesAndAnswers/commonAndDefaultAnswers/ConnectionAnswer.vue